var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page mt-0"},[(!_vm.error)?_c('h3',{staticClass:"success"},[_vm._v("Вы успешно отписаны от рассылки")]):_c('h2',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []

export { render, staticRenderFns }